const PsChartsDataUMA =  {
        'MATÉRIA PRIMA': [
            ['psAtrPcts', 'psAtrDigestor'],
            ['psFibraCana', 'psBagacoCana'],
            ['', ''],
        ],
        'MOAGEM': [
            ['psUptimeGeral', 'psDiasSafra'],
            ['psTaxaMoagem', 'psMoagemTotal'],
            ['', ''],
        ],
        'EFICIÊNCIAS': [
            ['psArtEntrado', 'psArtRecuperado'],
            ['psEficienciaIndustrial', 'psRTC'],
            ['psConsVaporTc', 'psPtConsumidaTC']
        ],
        'PERDAS': [
            ['psPerdaBagaco', 'psPerdaLavavem'],
            ['psPerdaTorta', 'psPerdaMultijato'],
            ['psPerdaFermentacao', 'psPerdaResiduaria'],
            ['psPerdaIndeterminada', '']
        ],
        'PRODUÇÕES': [
            ['psProdAcucarTotal', 'psProdAcucarTotalSC'],
            ['psProdEtanolTotalHid', 'psEnergiaExportada'],
            ['', ''],
            
        ],
        'ESTOQUES': [
            ['psEstoqueInicialBag', 'psEstoqueFinalBag'],
            ['', ''],
            ['', ''],
        ],
        'PAGE1': [
            ['psAtrDigestor', 'psFibraCana'],
            ['psUptimeGeral', 'psMoagemTotal'],
            ['psTaxaMoagem', 'psRTC'],
        ],
        'PAGE2': [
            ['psMixAcucar', 'psProdAcucarTotalSC'],
            ['psProdEtanolTotalHid', 'psEnergiaExportada'],
            ['psConsVaporTcTotal', 'psPtConsumidaTC'],
        ]
    }

export default PsChartsDataUMA;

